import React from 'react';
// Global library
// Module library
import RouteNotFoundContainer from './layouts/RouteNotFoundContainer';

export const RouteNotFound = () => {
  return <RouteNotFoundContainer />;
};
